import { getToken } from "./token";
import { ISurvey } from "./types";

const API_URL = process.env.REACT_APP_BASE_API_URL;
console.log(API_URL);

export async function login(name?: string, password?: string) {
  const email = `${name}@example.com`;

  const response = await fetch(`${API_URL}/Auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });

  if (!response.ok) throw new Error('Ошибка входа');
  return response.json(); // { token }
}

export async function validateToken(token: string) {
  const response = await fetch(`${API_URL}/Auth/validate-token`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ token })
  });
  if (!response.ok) throw new Error('Токен невалиден');
}

export async function getGuestSurvey(token: string) {
  const response = await fetch(`${API_URL}/GuestSurvey`, {
    headers: { 'Authorization': `Bearer ${token}` },
  });
  if (!response.ok) throw new Error('Ошибка загрузки опросника');
  return response.json();
}

export async function fulfillGuestSurvey(token: string, body: Omit<ISurvey, 'id' | 'guestId'>) {
  const response = await fetch(`${API_URL}/GuestSurvey`, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body: JSON.stringify(body),
  });
  if (!response.ok) throw new Error('Ошибка отправки опросника');
  return response.json();
}

export async function getUserInfo(token: string) {
  const response = await fetch(`${API_URL}/Auth/user-info`, {
    headers: { 'Authorization': `Bearer ${token}`},
    method: 'GET',
  });
  if (!response.ok) throw new Error('Невозможно получить данные о пользователе');
  return response.json();
}

export const runRequestWithToken = <T extends unknown[]>(
  func: (token: string, ...args: T) => Promise<unknown>,
  ...args: T
): Promise<unknown> => {
  const token = getToken();

  if (!token) {
    throw new Error('Токен не найден');
  }

  return func(token, ...args);
}
